import { getOssProxyOrFail } from "../api";

export async function getMetriportPatientId(patientId: string): Promise<string> {
  const apiOssProxy = getOssProxyOrFail();
  const resp = await apiOssProxy.get(`/patient/${patientId}`);
  if (!resp.data) throw new Error(`Patient ID not returned @ PracticeFusion`);
  return resp.data;
}

export async function getTermsOfServiceAccepted(): Promise<{
  isTermsOfServiceAccepted: boolean;
}> {
  const apiOssProxy = getOssProxyOrFail();
  const resp = await apiOssProxy.get(`/practice/terms-of-service`);
  return resp.data;
}

export async function acceptTermsOfService(): Promise<void> {
  const apiOssProxy = getOssProxyOrFail();
  await apiOssProxy.post(`/practice/terms-of-service`);
}
